<template>
  <div id="prop-page">
    <div class="container">
      <div class="row" style="padding-left: 16px;">
        <div class="medium-18" style="line-height: 2; margin-right: 15px;">เลือกทำเล</div>
        <vs-select placeholder="Select" v-model="value">
          <vs-option label="กรุงเทพและปริมณฑล" value="1">กรุงเทพและปริมณฑล</vs-option>
        </vs-select>
      </div>
    </div>
    <div class="space-header"></div>
    <div class="container invest-header">
      <div class="medium-18">สร้างการลงทุนใหม่</div>
    </div>
    <div class="container">
      <section>
        <vue-horizontal-list v-if="isLoaded" :items="newPropList" :options="options">
          <template v-slot:default="{ item }">
            <div class="carousel-box item">
              <!-- <h5>{{ item.title }}</h5>
              <p>{{ item.content }}</p>-->
              <PropertyListBox :propDetail="item"></PropertyListBox>
            </div>
          </template>
        </vue-horizontal-list>
      </section>
    </div>
    <div class="container invest-header" style="margin-top:2rem">
      <div class="medium-18">ร่วมลงทุนในอสังหาริมทรัพย์</div>
    </div>
    <div class="container">
      <section>
        <vue-horizontal-list v-if="isLoaded" :items="propSharingList" :options="options">
          <template v-slot:default="{ item }">
            <div class="carousel-box item">
              <!-- <h5>{{ item.title }}</h5>
              <p>{{ item.content }}</p>-->
              <PropertySharingBox :propDetail="item" :investor="propInvestGroup[item.index]"></PropertySharingBox>
            </div>
          </template>
        </vue-horizontal-list>
      </section>
    </div>
  </div>
</template>

<script>
import VueHorizontalList from 'vue-horizontal-list'
import PropertyListBox from '@/components/PropertyListBox'
import PropertySharingBox from '@/components/PropertySharingBox'
import { getProperties, getPropertiesInvestGroup, getPropertyInfo } from '@/firebase/firebase-transaction.js'
export default {
  name: 'PropertyPage',
  components: {
    VueHorizontalList,
    PropertyListBox,
    PropertySharingBox
  },
  data: () => ({
    options: {
      responsive: [{ end: 576, size: 1 }, { start: 576, end: 768, size: 2 }, { size: 3 }],
      list: {
        // 1200 because @media (min-width: 1200px) and therefore I want to switch to windowed mode
        windowed: 600,

        // Because: #app {padding: 80px 24px;}
        padding: 24
      },
      navigation: {
        // when to show navigation
        start: 500,
        color: '#000'
      }
    },
    newPropList: [],
    propSharingList: [],
    propInvestGroup: [],
    value: 1,
    isLoaded: false
  }),
  async created() {
    this.newPropList = await getProperties()
    this.propInvestGroup = await getPropertiesInvestGroup()
    for (var i = 0; i < this.propInvestGroup.length; i++) {
      var propItem = await getPropertyInfo(this.propInvestGroup[i].key)
      if (propItem !== null) {
        propItem.index = i
        this.propSharingList.push(propItem)
      }
    }
  },
  watch: {
    newPropList () {
      this.isLoaded = true
    }
  }
}
</script>

<style scoped>
#prop-page {
  padding: 30px 0px 15px 0px;
}

#prop-page >>> .vs-select-content {
  max-width: 400px;
}

.invest-header {
  padding: 15px;
  border: 1px solid rgba(63, 63, 68, 0.005);
  box-shadow: 0px 1px 0px rgba(63, 63, 68, 0.05), 0px 1px 3px rgba(63, 63, 68, 0.15);
  border-radius: 4px;
}

.space-header {
  height: 1rem;
}

.carousel-box {
  box-shadow: 0px 2px 4px 1px rgba(63, 63, 68, 0.35), 0px 2px 3px rgba(63, 63, 68, 0.75);
  border-radius: 4px;
}
</style>
